export default class Connector {
  constructor(adGroupNameObservable, budgetAmountObservable, keywordsView, searchBidView) {
    this.searchBidView = searchBidView;

    if (adGroupNameObservable) {
      adGroupNameObservable.subscribe(this.updateAdgroupName, this);
    }

    if (budgetAmountObservable) {
      budgetAmountObservable.subscribe(this.updateBudgetAmount, this);
    }

    if (keywordsView) {
      keywordsView.on('keywords:updated', () => this.updateKeywords());
      keywordsView.on('keywords:outTextArea', () => this.onKeywordsEditted());
      keywordsView.on('keywords:addSuggestion', () => this.onKeywordsEditted());
    }
  }

  updateAdgroupName(newName) {
    if (this.searchBidView) {
      this.searchBidView.clearEstimation();
      this.searchBidView.updateAdGroupName(newName);
    }
  }

  updateBudgetAmount(newBudgetAmount) {
    if (this.searchBidView) {
      this.searchBidView.clearEstimation();
      this.searchBidView.updateBudgetAmount(newBudgetAmount);
    }
  }

  updateKeywords() {
    if (this.searchBidView) {
      this.searchBidView.clearEstimation();
    }
  }

  onKeywordsEditted() {
    if (this.searchBidView) {
      this.searchBidView.onKeywordsEditingFinished();
    }
  }
}
